/**
 * 腾讯防水墙的设置
 * */
export const tencentCaptchaAppId = "199784021"



// WEBPACK FOOTER //
// ./resources/js/config/tencentCaptchConfig.js